module.exports = __webpack_public_path__ + "img/no-yearly-team-rating.cdf28372.png";